import { jsonArray, jsonValue } from '../types/jsonValue';

export const toFirstString = (value: jsonValue | jsonArray | null): string | null => {
  if (value == null) return null;

  if (Array.isArray(value)) {
    return value[0] != null ? String(value[0]) : null;
  }
  return String(value);

}
